import api from '../../plugins/api';

//отменить заявку с финансированием
const cancelLoanApplication = ({ bankOwnerId, chunkId }) => {
  return api.post('/api/bank/cancelLoanApplication', { sourceId: bankOwnerId, chunkId });
};

export default cancelLoanApplication;
